exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sms-textarea-wrapper[data-v-48f6126c]{border:1px solid #ddd;border-radius:4px;padding:6px}.sms-textarea[data-v-48f6126c]{border:0;-webkit-box-shadow:none;box-shadow:none;padding:0;resize:none}.advertisement-confirm[data-v-48f6126c]{color:red;font-size:.9rem}.msg-box[data-v-48f6126c]{border:1px solid #ccc;border-radius:4px;padding:14px;min-height:350px;height:350px;overflow:scroll}", ""]);

// exports
